import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import {ApiResultVo} from '../../common/shared/api/karina/vo/ApiResultVo.interface';
import {LayoutVo} from '../../common/shared/api/karina/vo/LayoutVo.interface';
import {createReferenceRequestVo} from '../../graphql/factory/DataKey';

export async function getLayoutReferenceViewData({
  dataKeyList,
  options,
}: {
  dataKeyList: string[];
  options?: FetcherOptions;
}): Promise<ApiResultVo<LayoutVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/view/v1/source',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        reference: dataKeyList.map(createReferenceRequestVo),
      },
    },
    options
  );
  return response.data;
}
